export type ApiErrorType = {
    // data: {} | [] | null;  // HTTP status code (e.g., 401, 400)
    errors: {
        customError: String,
        errorCode: String,
        message: String,
        redirect: string
    },
    isApiError: boolean
};

export const checkUserLogin = (user: any) => {
    if (user && user?.token && user?.email) return true
    return false
}